// extracted by mini-css-extract-plugin
export var centerText = "_et-8";
export var container = "_et-0";
export var doughnutContainer = "_et-7";
export var legend = "_et-a";
export var legendItemColorDisplay = "_et-b";
export var legendItemLabel = "_et-d";
export var legendItemValue = "_et-c";
export var lg = "_et-5";
export var maxWidth = "_et-9";
export var md = "_et-4";
export var responsive = "_et-6";
export var sm = "_et-3";
export var xs = "_et-2";
export var xxs = "_et-1";